// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bbf_a bfq_cw bfq_jx bfq_jo bfq_rg bfq_vc"};